import { useEffect, useState } from "react";

import { t } from "../../utils/ResourceUtils";

export const Timer = ({ expiresIn, handleTimeOut }) => {
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);
  const [timeLeft, setTimeLeft] = useState(expiresIn);

  const formatTime = (t) => (t < 10 ? "0" + t : t);

  useEffect(() => {
    if (!timeLeft) {
      handleTimeOut();
      return;
    }
    const interval = setInterval(() => {
      const m = Math.floor(timeLeft / 60);
      const s = timeLeft - m * 60;
      setMin(m);
      setSec(s);
      if (m <= 0 && s <= 0) return () => clearInterval(interval);

      setTimeLeft((t) => t - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  return (
    <div className={`timer ${timeLeft <= 60 ? "timer-warning" : ""}`}>
      <span>{formatTime(min)}</span> :{" "}
      <span>
        {formatTime(sec)} {t("cm.mins_left")}
      </span>
    </div>
  );
};

export default Timer;
